import { render, staticRenderFns } from "./ModalBloqueio.vue?vue&type=template&id=5bbb4e5c&scoped=true"
import script from "./ModalBloqueio.vue?vue&type=script&lang=js"
export * from "./ModalBloqueio.vue?vue&type=script&lang=js"
import style0 from "./ModalBloqueio.vue?vue&type=style&index=0&id=5bbb4e5c&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bbb4e5c",
  null
  
)

export default component.exports